// extracted by mini-css-extract-plugin
export default {"QuantitySelector":"QuantitySelector_QuantitySelector__T-rnd"};